import {z} from 'zod';

export const WorkshopUnitFormSchema = z.object({
  name: z.string(),
});

export type WorkshopUnitForm = z.infer<typeof WorkshopUnitFormSchema>;
